/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCalendarCenterSupplier } from './MstCalendarCenterSupplier';
import {
    MstCalendarCenterSupplierFromJSON,
    MstCalendarCenterSupplierFromJSONTyped,
    MstCalendarCenterSupplierToJSON,
    MstCalendarCenterSupplierToJSONTyped,
} from './MstCalendarCenterSupplier';

/**
 * 
 * @export
 * @interface CalendarCenterSupplier
 */
export interface CalendarCenterSupplier {
    /**
     * 
     * @type {number}
     * @memberof CalendarCenterSupplier
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalendarCenterSupplier
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CalendarCenterSupplier
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Array<MstCalendarCenterSupplier>}
     * @memberof CalendarCenterSupplier
     */
    list: Array<MstCalendarCenterSupplier>;
}

/**
 * Check if a given object implements the CalendarCenterSupplier interface.
 */
export function instanceOfCalendarCenterSupplier(value: object): value is CalendarCenterSupplier {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    return true;
}

export function CalendarCenterSupplierFromJSON(json: any): CalendarCenterSupplier {
    return CalendarCenterSupplierFromJSONTyped(json, false);
}

export function CalendarCenterSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarCenterSupplier {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'list': ((json['list'] as Array<any>).map(MstCalendarCenterSupplierFromJSON)),
    };
}

export function CalendarCenterSupplierToJSON(json: any): CalendarCenterSupplier {
    return CalendarCenterSupplierToJSONTyped(json, false);
}

export function CalendarCenterSupplierToJSONTyped(value?: CalendarCenterSupplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'list': ((value['list'] as Array<any>).map(MstCalendarCenterSupplierToJSON)),
    };
}

